import DropdownFilters from "../../../components/dropdown-filters/dropdown-filters";
import Header from "../../../components/header/header";
import { useCan } from "../../../common/utils/usePermissions";

const AuditTrailHeader = ({
  t,
  filterItems,
  updateFilterValue,
  exportTrail,
}) => {
  // The export reads the same trail the table does.
  const canExport = useCan("analytics.audit");

  return (
    <Header
      title={t("trails.title")}
      filters={
        <DropdownFilters
          filtersBy={filterItems}
          updateFilterValue={updateFilterValue}
        />
      }
      create={
        // A tab without an export (AI calls) offers none.
        canExport && exportTrail
          ? { label: t("trails.export"), onClick: exportTrail }
          : undefined
      }
    />
  );
};

export default AuditTrailHeader;
